module.exports = __webpack_public_path__ + "img/icon_404.2d4bf663.png";